<template>
  <div
    v-if="prevSection || nextSection || nextTest"
    class="border p-4 mt-5 rounded"
  >
    <p v-if="nextSection" class="text-center small">
      გაგრძელებისთვის დააჭირეთ ღილაკს "შემდეგი"
    </p>
    <p v-if="nextTest" class="text-center small">
      {{ testText }}
    </p>
    <div class="text-center">
      <router-link
        v-if="prevSection"
        :to="{ name: 'section', params: { id: prevSection } }"
        class="btn btn-outline-primary me-3 rounded-pill px-4"
        >უკან</router-link
      >
      <router-link
        v-if="nextSection"
        :to="{ name: 'section', params: { id: nextSection } }"
        class="btn btn-outline-primary rounded-pill px-4"
        >შემდეგი</router-link
      >
      <router-link
        v-if="nextTest"
        :to="{ name: 'test', params: { id: nextTest } }"
        class="btn btn-outline-primary rounded-pill px-4"
        >შემდეგი</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["prevSection", "nextSection", "nextTest", "testText"],
};
</script>

<style>
</style>